const PartnerApi = {
    postCreate: '/crud/partners',
    postAction: '/crud/partners/:id/action',
    postOrder: '/crud/partners/:id/order',

    putUpdate: '/crud/partners/:id',

    deleteDestroy: '/crud/partners/:id',

    getIndex: '/crud/partners',
    getSelect: '/crud/partners/select',
    getId: '/crud/partners/:id',
}

export default PartnerApi;
